import _SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import css from './css.module.less';
import React from 'react';

const SectionWrapper = (props) => {
  const { children, ...rest } = props;
  return (
    <_SectionWrapper containerClassName={css.containerClassName} {...rest}>
      {children}
    </_SectionWrapper>
  );
};
export default SectionWrapper;
